import { css } from 'emotion';

export const payNow = css({
    marginRight: '0.4em',
  });